import { Alert } from 'antd';
import React, { FC } from 'react';

export const BannerDemoPage: FC = () => {
  return <Alert message="Warning text" banner />;
};
